import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl'

const NonAvailableSuppliersWidget = ({widget}) => {
  const mounted = useRef(false);

  const [suppliers, setSuppliers] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    mounted.current = true;
    fetch('coordinatordashboard/Non_Available_Suppliers')
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setSuppliers(data.data.suppliers);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const getStartDate = (supplier) => {
    if (supplier && supplier['availability'] && supplier['availability'].length > 0) {
      const value = new Date(supplier['availability'][0]['dateStart'] * 1000)
      return <div>
        <span className="mr-1">
          <FormattedDate value={value} />
        </span>
        <span>
          <FormattedTime value={value} />
        </span>
      </div>
    } else {
      return null;
    }
  };

  const getEndDate = (supplier) => {
    if (supplier && supplier['availability'] && supplier['availability'].length > 0) {
      const value = new Date(supplier['availability'][0]['dateEnd'] * 1000)
      return <div>
        <span className="mr-1">
          <FormattedDate value={value} />
        </span>
        <span>
          <FormattedTime value={value} />
        </span>
      </div>
    } else {
      return null;
    }
  };

  const supplierDetails = (uid) => {
    reactHistory.push(`/suppliers/${uid}/data`)
  };

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <div className="bg-white border shadow rounded border-gray-400" id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <table className="w-full table-fixed text-xs">
        <thead>
          <tr>
              <td className="border-b p-2 w-3/12 truncate">Supplier</td>
              <td className="border-b p-2 w-3/12">Between</td>
              <td className="border-b p-2 w-6/12">Description</td>
          </tr>
        </thead>

        <tbody>
          {suppliers.map((supplier) => (
            <tr key={supplier['uid']} className="hover:bg-gray-200 cursor-pointer" onClick={() => supplierDetails(supplier['uid'])}>
                <td className="border-b p-2 w-3/12">
                    {supplier['userid']}
                </td>
                <td className="border-b p-2 w-3/12">
                    <div>{getStartDate(supplier)}</div>
                    <div>{getEndDate(supplier)}</div>
                </td>
                <td className="border-b p-2 w-6/12">
                  { supplier && supplier['availability'] && supplier['availability'].length > 0 ? supplier['availability'][0]['message'] : '' }
                </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

}

export default NonAvailableSuppliersWidget;
